<template>
    <div>
        <loading-component v-if="loading"></loading-component>
        <Select filterable v-model="buffer" v-else>
            <Option
                v-for="property in sorted"
                :key="property.attribute"
                :value="property.attribute"
                >{{ property.label }}</Option
            >
        </Select>
    </div>
</template>

<script>
export default {
    props: {
        loading: Boolean,
        value: String,
        providerAttributes: Array,
    },
    data() {
        return {
            buffer: this.value,
        };
    },
    computed: {
        sorted() {
            return _.sortBy(this.providerAttributes, "label");
        },
    },
    watch: {
        buffer() {
            this.$emit("input", this.buffer);
        },
        value() {
            this.buffer = this.value;
        },
    },
};
</script>
